// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__XEh_Y","choiceBoxes":"toolbarselects_choiceBoxes__3N-1J","simpleField":"toolbarselects_simpleField__1hH8d"};